export default __webpack_public_path__ + "static/ring5-befcf0edf978741d3d864b16bc0cd171.png";